import MyAccountEdit from './MyAccountEdit.container';

export default MyAccountEdit;
